module.exports = __webpack_public_path__ + "static/UNITY-TOWER-2nd-floor-traditional_v2-en-a1adb434f2fc54fb400292f7554ca0b5.pdf";